import {
  Injectable,
  Injector,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ApplicationRef,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';

export class ModalComponent {
  data = new Subject();
  resolve = new Subject();
}

@Injectable()
export class ModalService {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  appendComponentToBody(component, data): Observable<any> {
    const resolvedData = new Subject();

    // Create a component reference from the component
    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(component)
      .create(this.injector);

    // assign input and output data
    componentRef.instance['data'].next(data);
    componentRef.instance['resolve'].subscribe(res => {
      // retrieve data and destroy modal
      resolvedData.next(res);
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();

      document.body.style.maxHeight = 'unset';
      document.body.style.overflow = 'unset';
    });

    // Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(componentRef.hostView);

    // Get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // Append DOM element to the body

    document.body.style.maxHeight = '100vh';
    document.body.style.overflow = 'hidden';

    document.body.appendChild(domElem);

    return resolvedData.asObservable();
  }
}
